import { SnackbarService } from './../shared/services/snackbar.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { CONSTANTS } from './constants';
import * as i0 from "@angular/core";
import * as i1 from "./services/snackbar.service";
var UtilService = /** @class */ (function () {
    function UtilService(snackbarService) {
        var _this = this;
        this.snackbarService = snackbarService;
        this.minFileSizeBytes = 1;
        this.maxFileSizeBytes = 26214400; // 25Mb
        this.maxPackageSizeBytes = 41943040; // 40Mb
        this.validExtensions = ['pdf', 'xls', 'xlsx', 'png', 'jpeg', 'jpg', 'doc', 'docx', 'txt', 'xml'];
        this.validMimeTypes = [
            'image/png',
            'image/jpeg',
            'image/pjpeg',
            'application/pdf',
            'application/msword',
            'application/excel',
            'application/x-excel',
            'application/x-msexcel',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/xml',
            'text/xml',
            'text/plain'
        ];
        this.b64ToUint6 = function (nChr) {
            return nChr > 64 && nChr < 91 ?
                nChr - 65
                : nChr > 96 && nChr < 123 ?
                    nChr - 71
                    : nChr > 47 && nChr < 58 ?
                        nChr + 4
                        : nChr === 43 ?
                            62
                            : nChr === 47 ?
                                63
                                :
                                    0;
        };
        this.base64DecToArr = function (sBase64, nBlocksSize) {
            var sB64Enc = sBase64.replace(/[^A-Za-z0-9\+\/]/g, '');
            var nInLen = sB64Enc.length;
            // tslint:disable-next-line: no-bitwise
            var nOutLen = nBlocksSize ? Math.ceil((nInLen * 3 + 1 >> 2) / nBlocksSize) * nBlocksSize : nInLen * 3 + 1 >> 2;
            var taBytes = new Uint8Array(nOutLen);
            for (var nMod3 = void 0, nMod4 = void 0, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++) {
                nMod4 = nInIdx & 3;
                // tslint:disable-next-line: no-bitwise
                nUint24 |= _this.b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 18 - 6 * nMod4;
                if (nMod4 === 3 || nInLen - nInIdx === 1) {
                    for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++) {
                        // tslint:disable-next-line: no-bitwise
                        taBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255;
                    }
                    nUint24 = 0;
                }
            }
            return taBytes;
        };
        this.getTotalSize = function (filesToUpload) {
            var sum = 0;
            filesToUpload.forEach(function (f) { return sum = sum + f.size; });
            return sum;
        };
        this.validateSize = function (file, filePackage) {
            var msg = '';
            if (file.size < _this.minFileSizeBytes) {
                msg = 'O arquivo não pode ser vazio.';
                _this.showSnackbar(msg);
                return false;
            }
            if (file.size > _this.maxFileSizeBytes) {
                msg = 'O tamanho do arquivo ultrapassa o limite de 25mb.';
                _this.showSnackbar(msg);
                return false;
            }
            if (!_this.checkExistenceByName(file.name, filePackage)) {
                if ((_this.getTotalSize(filePackage) + file.size) > _this.maxPackageSizeBytes) {
                    msg = 'O tamanho total ultrapassa o limite de 40mb.';
                    _this.showSnackbar(msg);
                    return false;
                }
            }
            return true;
        };
        this.checkExtension = function (file) {
            var fileExtension = file.name.split('.').pop();
            var mimeType = file.type;
            var msg = '';
            if (!_this.validExtensions.includes(fileExtension.toLowerCase())) {
                msg = 'O tipo do arquivo não é permitido: ' + fileExtension.toLowerCase();
                _this.showSnackbar(msg);
                return false;
            }
            if (!_this.validMimeTypes.includes(mimeType.toLowerCase())) {
                msg = 'O tipo do arquivo não é permitido: ' + mimeType.toLowerCase();
                _this.showSnackbar(msg);
                return false;
            }
            return true;
        };
        this.checkSizeNameAttachments = function (file) {
            if (file.name.length > 200) {
                var msg = 'O nome do arquivo deve conter até 200 caracteres.';
                _this.showSnackbar(msg);
                return false;
            }
            return true;
        };
        this.checkExistenceByName = function (name, files) {
            return (files.findIndex(function (upload) { return upload.name === name; }) > -1);
        };
    }
    // Function to show snack bar
    UtilService.prototype.showSnackbar = function (message, action) {
        this.snackbarService.showSnackbar(message, action ? action : CONSTANTS.GLOBAL.OK.toUpperCase());
    };
    UtilService.prototype.downloadFileBlob = function (blob, fileName) {
        try {
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, fileName);
            }
            else {
                var elem = window.document.createElement('a');
                elem.href = window.URL.createObjectURL(blob);
                elem.download = fileName;
                document.body.appendChild(elem);
                elem.click();
                document.body.removeChild(elem);
            }
        }
        catch (e) {
            throw Error(e);
        }
    };
    UtilService.prototype.getSizeFileText = function (data) {
        if (typeof data !== 'string') {
            data = data.size;
        }
        return (data / Math.pow(1024, 2)).toFixed(2).replace(/[.,]00$/, '') + ' ' + 'MB';
    };
    UtilService.prototype.convertByteJsonToBlob = function (contentFile, contentType) {
        var uriEncodedString = decodeURIComponent(contentFile);
        var typeFile = contentType ? contentType : 'application/octet-stream';
        return new Blob([this.base64DecToArr(uriEncodedString)], { type: typeFile });
    };
    UtilService.prototype.validateFileToUpload = function (event, filesToUpload, eventFilesUpload) {
        var maxLenghtNameDocument = 40;
        if (event.target.files[0]) {
            var file = event.target.files[0];
            if (file.name && !this.checkExistenceByName(file.name, filesToUpload)
                && this.validateSize(file, filesToUpload) && this.checkExtension(file)
                && this.checkSizeNameAttachments(file)) {
                var infoNameDocument = file.name.split('.');
                if (infoNameDocument[0].length > maxLenghtNameDocument) {
                    file.nameSimplyfied = infoNameDocument[0].substring(0, maxLenghtNameDocument) + "..." + infoNameDocument[1];
                }
                filesToUpload.push(file);
                if (eventFilesUpload) {
                    eventFilesUpload.emit(filesToUpload);
                }
            }
        }
    };
    UtilService.prototype.convertPayloadFileToFormData = function (payload, namePayload, files) {
        var formData = new FormData;
        formData.append(namePayload, new Blob([JSON.stringify(payload)], {
            type: 'application/json'
        }));
        Array.from(files).forEach(function (file) { return formData.append('files', file, file.name); });
        return formData;
    };
    UtilService.prototype.handleStatusProgressLoading = function (event, value, message) {
        var isCompleted = false;
        if (event.type === HttpEventType.UploadProgress) {
            value = Math.round(100 * event.loaded / event.total);
        }
        else if (event instanceof HttpResponse) {
            this.showSnackbar(message);
            isCompleted = true;
        }
        return isCompleted;
    };
    UtilService.prototype.containsTypeOpenImpl = function (name) {
        var nameNormalize = this.accentsTidy(name);
        var containsOpenType = nameNormalize.toLowerCase() === 'abertura';
        var containsOpenTypeImp = nameNormalize.toLowerCase().includes('implantacao');
        return containsOpenType || containsOpenTypeImp;
    };
    UtilService.prototype.accentsTidy = function (s) {
        var r = s.toLowerCase();
        var non_asciis = { 'a': '[àáâãäå]', 'ae': 'æ', 'c': 'ç', 'e': '[èéêë]', 'i': '[ìíîï]', 'n': 'ñ', 'o': '[òóôõö]', 'oe': 'œ', 'u': '[ùúûűü]', 'y': '[ýÿ]' };
        for (var i in non_asciis) {
            r = r.replace(new RegExp(non_asciis[i], 'g'), i);
        }
        return r;
    };
    UtilService.prototype.setValuePropertyHTML = function (id, value) {
        document.getElementById(id).value = value;
    };
    UtilService.prototype.requestFocus = function (id) {
        document.getElementById(id).focus();
    };
    UtilService.prototype.getFirstElememtByClassName = function (className) {
        var item = document.getElementsByClassName(className)[0];
        return item;
    };
    UtilService.prototype.requestFocusOnFirstOcurrence = function (className) {
        var item = document.getElementsByClassName(className)[0];
        if (item != undefined) {
            item.focus();
        }
    };
    UtilService.prototype.isHomePageOrBrowserWarning = function () {
        return window.location.hash === '#/' || window.location.hash === '#/browser-warning';
    };
    UtilService.prototype.handleNullOrUndefined = function (element) {
        return element !== null && element !== undefined ? element : '';
    };
    UtilService.ngInjectableDef = i0.defineInjectable({ factory: function UtilService_Factory() { return new UtilService(i0.inject(i1.SnackbarService)); }, token: UtilService, providedIn: "root" });
    return UtilService;
}());
export { UtilService };
export var isMobile = window.innerWidth <= 760;
export var datePad = function (date) {
    if (!String.prototype.padStart) {
        String.prototype.padStart = function padStart(targetLength, padString) {
            targetLength = targetLength >> 0;
            padString = String((typeof padString !== 'undefined' ? padString : ' '));
            if (this.length > targetLength) {
                return String(this);
            }
            else {
                targetLength = targetLength - this.length;
                if (targetLength > padString.length) {
                    padString += padString.repeat(targetLength / padString.length);
                }
                return padString.slice(0, targetLength) + String(this);
            }
        };
    }
    return ("" + date).padStart(2, '0');
};
export function formatCurrency(number) {
    var value = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    return value.format(number);
}
export function formatZeroPad(num) {
    return String("00000000" + num).slice(-8);
}
export function preventWeekendFilter(d) {
    var day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
}
export function addDateMask(evento) {
    var v = evento.target.value;
    if (evento.key != 'Backspace') {
        if (v.match(/^\d{2}$/) !== null) {
            evento.target.value = v + '/';
        }
        else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
            evento.target.value = v + '/';
        }
    }
    return evento.target.value;
}
export function ptDateMask(control) {
    var ptDatePattern = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/g;
    var val = control.value;
    if (val != null && val != '' && val instanceof String) {
        if (!val.match(ptDatePattern))
            return { "ptDate": true };
    }
    return null;
}
export function padEndSuport() {
    if (!String.prototype.padEnd) {
        String.prototype.padEnd = function padEnd(targetLength, padString) {
            targetLength = targetLength >> 0;
            padString = String((typeof padString !== 'undefined' ? padString : ' '));
            if (this.length > targetLength) {
                return String(this);
            }
            else {
                targetLength = targetLength - this.length;
                if (targetLength > padString.length) {
                    padString += padString.repeat(targetLength / padString.length);
                }
                return String(this) + padString.slice(0, targetLength);
            }
        };
    }
}
// Fallback simples para PT-BR caso normalize não esteja disponível (IE11).
var DIACRITICS_MAP = {
    'Á': 'A', 'À': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'á': 'a', 'à': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a',
    'É': 'E', 'È': 'E', 'Ê': 'E', 'Ë': 'E', 'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
    'Í': 'I', 'Ì': 'I', 'Î': 'I', 'Ï': 'I', 'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i',
    'Ó': 'O', 'Ò': 'O', 'Ô': 'O', 'Õ': 'O', 'Ö': 'O', 'ó': 'o', 'ò': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
    'Ú': 'U', 'Ù': 'U', 'Û': 'U', 'Ü': 'U', 'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
    'Ç': 'C', 'ç': 'c', 'Ñ': 'N', 'ñ': 'n'
};
function removeDiacritics(input) {
    if (typeof String.prototype.normalize === 'function') {
        return input.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return input.replace(/[^\x20-\x7E]/g, function (ch) { return (DIACRITICS_MAP[ch] !== undefined ? DIACRITICS_MAP[ch] : ch); });
}
//
// Escapa caracteres especiais em classes de caracteres de RegExp ([], ex.: '-', '' e '^')
function escapeForCharClass(s) {
    return s.replace(/[-\^]/g, '\$&');
}
// remove hífens no início e fim sem regex dinâmica
function trimHyphens(input) {
    if (!input)
        return '';
    var HYPHEN = 45; // '-'
    var start = 0;
    var end = input.length;
    while (start < end && input.charCodeAt(start) === HYPHEN)
        start++;
    while (end > start && input.charCodeAt(end - 1) === HYPHEN)
        end--;
    return input.slice(start, end);
}
// Colapsa todos os ":" consecutivos em um único ":" e remove ":" nas bordas
function collapseAndTrimColons(value) {
    if (!value)
        return '';
    var COLON = 58; // ':'
    // trim ":" nas bordas
    var start = 0;
    var end = value.length;
    while (start < end && value.charCodeAt(start) === COLON)
        start++;
    while (end > start && value.charCodeAt(end - 1) === COLON)
        end--;
    if (start === end)
        return '';
    // colapsa ":" no miolo
    var out = '';
    var prevWasColon = false;
    for (var i = start; i < end; i++) {
        var code = value.charCodeAt(i);
        if (code === COLON) {
            if (!prevWasColon) {
                out += ':';
                prevWasColon = true;
            }
        }
        else {
            out += value.charAt(i);
            prevWasColon = false;
        }
    }
    return out;
}
// Remove o replacement (ex.: '-') imediatamente antes/depois de ":" (ex.: "-:" -> ":", ":-" -> ":")
// Sem regex, compatível com TS 3.2
function normalizeReplacementAroundColon(value, replacement) {
    if (!value)
        return '';
    if (!replacement || replacement.length !== 1)
        return value;
    var REP = replacement.charCodeAt(0);
    var COLON = 58;
    var out = '';
    for (var i = 0; i < value.length; i++) {
        var curr = value.charCodeAt(i);
        var next = i + 1 < value.length ? value.charCodeAt(i + 1) : -1;
        // Caso "-:" (ou REP+":"), pulamos o replacement; o ":" será processado na próxima iteração
        if (curr === REP && next === COLON) {
            continue;
        }
        if (curr === COLON) {
            // Adiciona ":" e pula todos os replacements seguintes imediatos, cobrindo ":-", ":- -", etc.
            out += ':';
            while (i + 1 < value.length && value.charCodeAt(i + 1) === REP) {
                i++;
            }
            continue;
        }
        out += value.charAt(i);
    }
    return out;
}
function isWhitespaceCode(c) {
    // espaço, tab, LF, VT, FF, CR
    return c === 32 || c === 9 || c === 10 || c === 11 || c === 12 || c === 13;
}
// Split por '>', ':', '/', '|' com espaços opcionais
export function splitBreadcrumbPartsNoRegex(input) {
    var s = input != null ? String(input) : '';
    if (!s)
        return [];
    var parts = [];
    var buf = '';
    var len = s.length;
    // códigos ASCII dos separadores
    var GT = 62; // '>'
    var SL = 47; // '/'
    var PIPE = 124; // '|'
    var COLON = 58; // ':'
    for (var i = 0; i < len; i++) {
        var code = s.charCodeAt(i);
        if (code === GT || code === SL || code === PIPE || code === COLON) {
            // fecha token atual
            var token = buf.trim();
            if (token)
                parts.push(token);
            buf = '';
            // pula espaços e separadores consecutivos
            while (i + 1 < len) {
                var nextCode = s.charCodeAt(i + 1);
                if (nextCode === GT || nextCode === SL || nextCode === PIPE || nextCode === COLON || isWhitespaceCode(nextCode)) {
                    i++;
                }
                else {
                    break;
                }
            }
        }
        else {
            buf += s.charAt(i);
        }
    }
    // último token
    var last = buf.trim();
    if (last)
        parts.push(last);
    return parts;
}
function trimEdgeSlashes(s) {
    if (!s)
        return '';
    var SLASH = 47;
    var start = 0;
    var end = s.length;
    while (start < end && s.charCodeAt(start) === SLASH)
        start++;
    while (end > start && s.charCodeAt(end - 1) === SLASH)
        end--;
    return s.slice(start, end);
}
function collapseSlashes(s) {
    if (!s)
        return '';
    var SLASH = 47;
    var out = '';
    var prevSlash = false;
    for (var i = 0; i < s.length; i++) {
        var code = s.charCodeAt(i);
        if (code === SLASH) {
            if (!prevSlash) {
                out += '/';
                prevSlash = true;
            }
        }
        else {
            out += s.charAt(i);
            prevSlash = false;
        }
    }
    return out;
}
function trimTrailingSlashes(s) {
    if (!s)
        return '';
    var SLASH = 47;
    var end = s.length;
    while (end > 0 && s.charCodeAt(end - 1) === SLASH)
        end--;
    return s.slice(0, end);
}
// Colapsa múltiplos slashes e remove slashes finais (sem remover o inicial)
export function normalizeSlashesNoRegex(s) {
    return trimTrailingSlashes(collapseSlashes(s));
}
export function sanitizeLabel(input, opts) {
    if (opts === void 0) { opts = { allowedSeparators: ':-', replacement: '-', trimEdges: true }; }
    var allowedSeparatorsRaw = (opts && opts.allowedSeparators != null) ? opts.allowedSeparators : ':-';
    var replacement = (opts && opts.replacement != null) ? opts.replacement : '-';
    var trimEdges = (opts && typeof opts.trimEdges === 'boolean') ? opts.trimEdges : true;
    var allowedSeparators = escapeForCharClass(allowedSeparatorsRaw);
    var s = (input != null ? input : '').toString();
    if (!s)
        return '';
    s = removeDiacritics(s).toLowerCase();
    // Converte qualquer sequência de caracteres inválidos para o separador escolhido
    s = s.replace(new RegExp("[^a-z0-9" + allowedSeparators + "]+", 'g'), replacement);
    // Colapsa separadores repetidos
    var repEsc = escapeForCharClass(replacement);
    s = s.replace(new RegExp(repEsc + "{2,}", 'g'), replacement);
    // Normaliza hifens próximos de ":" (evita "-:" e ":-")
    s = s.replace(new RegExp(repEsc + "+:", 'g'), ':');
    s = s.replace(new RegExp(":" + repEsc + "+", 'g'), ':');
    // Colapsa múltiplos ":" e remove ":" nas bordas
    s = normalizeReplacementAroundColon(s, replacement);
    s = collapseAndTrimColons(s);
    // Remove separadores nas bordas, se configurado
    if (trimEdges) {
        var repEscPattern = new RegExp("^" + repEsc + "+|" + repEsc + "+$");
        s = s.replace(repEscPattern, '');
    }
    // Remove traço final, se existir
    if (s.endsWith('-')) {
        s = s.slice(0, -1);
    }
    return s;
}
// Caso receba uma string inteira já com separadores, pode sanitizar direto
export function sanitizeDetail(detail) {
    return sanitizeLabel(detail, { allowedSeparators: ':-', replacement: '-', trimEdges: true });
}
// Remove acentos (sem depender de normalize) e normaliza para slug simples
export function removeAccentsPtBR(value) {
    if (!value)
        return '';
    return value
        .replace(/[ÁÀÂÃÄ]/g, 'A').replace(/[áàâãä]/g, 'a')
        .replace(/[ÉÈÊË]/g, 'E').replace(/[éèêë]/g, 'e')
        .replace(/[ÍÌÎÏ]/g, 'I').replace(/[íìîï]/g, 'i')
        .replace(/[ÓÒÔÕÖ]/g, 'O').replace(/[óòôõö]/g, 'o')
        .replace(/[ÚÙÛÜ]/g, 'U').replace(/[úùûü]/g, 'u')
        .replace(/[Ç]/g, 'C').replace(/[ç]/g, 'c');
}
export function tryDecode(value) {
    try {
        return decodeURIComponent(value);
    }
    catch (_a) {
        return value;
    }
}
export function slugify(value) {
    if (!value)
        return '';
    var decoded = tryDecode(value);
    var noAccents = removeAccentsPtBR(decoded);
    var normalized = noAccents.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    return trimHyphens(normalized);
}
export function splitBreadcrumbByChevronOnly(input) {
    var s = input != null ? String(input) : '';
    if (!s)
        return [];
    var GT = 62; // '>'
    var parts = [];
    var buf = '';
    for (var i = 0; i < s.length; i++) {
        var code = s.charCodeAt(i);
        if (code === GT) {
            var token = buf.trim();
            if (token)
                parts.push(token);
            buf = '';
            // pular '>' e espaços consecutivos
            while (i + 1 < s.length) {
                var next = s.charCodeAt(i + 1);
                if (next === GT || isWhitespaceCode(next)) {
                    i++;
                }
                else {
                    break;
                }
            }
        }
        else {
            buf += s.charAt(i);
        }
    }
    var last = buf.trim();
    if (last)
        parts.push(last);
    return parts;
}
export function normalizePath(url, options) {
    var opts = options || {};
    var prefix = trimEdgeSlashes((opts.prefix || '/iss').toLowerCase());
    var fallback = opts.fallback || '/iss/home';
    // Remove query/hash e matrix params
    var raw = (url || '');
    var noQuery = raw.split('?')[0];
    var noHash = noQuery.split('#')[0];
    var noMatrix = noHash.replace(/;[^/]+/g, '');
    // Sanitiza cada segmento do path
    var segs = noMatrix
        .split('/')
        .map(function (s) { return slugify(s); })
        .filter(function (s) { return !!s; });
    // Helper para sanitizar e retornar fallback
    function sanitizedFallback() {
        var fbSegs = (fallback || '/iss/home')
            .split('/')
            .map(function (s) { return slugify(s); })
            .filter(function (s) { return !!s; });
        var fbPath = '/' + fbSegs.join('/');
        fbPath = normalizeSlashesNoRegex(fbPath);
        return fbPath;
    }
    // Prefixo em segmentos (para evitar duplicação e tratar "apenas prefixo")
    var baseSegs = prefix
        ? prefix.split('/').map(function (s) { return slugify(s); }).filter(function (s) { return !!s; })
        : [];
    // Se não houver path, usa fallback
    if (!segs.length) {
        return sanitizedFallback();
    }
    // Evita duplicação do prefixo e trata caso "apenas prefixo"
    var resultSegs;
    var startsWithBase = baseSegs.length > 0 && segs.slice(0, baseSegs.length).join('/') === baseSegs.join('/');
    if (startsWithBase) {
        if (segs.length === baseSegs.length) {
            // path é exatamente "/iss" ou "/iss/"
            return sanitizedFallback();
        }
        // Já tem o prefixo corretamente uma única vez
        resultSegs = segs;
    }
    else {
        resultSegs = baseSegs.concat(segs);
    }
    var result = '/' + resultSegs.join('/');
    result = normalizeSlashesNoRegex(result);
    // Safety extra: se por algum motivo ficou apenas o prefixo, usa fallback
    if (baseSegs.length && result === '/' + baseSegs.join('/')) {
        return sanitizedFallback();
    }
    return result;
}
export function detailFromBreadcrumb(input, contexto) {
    var parts = splitBreadcrumbByChevronOnly(input);
    var slugs = parts.map(slugify).filter(Boolean);
    return contexto ? contexto + slugs.join(':') : 'menu-' + slugs.join(':');
}
export function normalizePathFromBreadcrumb(input, options) {
    var opts = options || {};
    var prefix = trimEdgeSlashes((opts.prefix || '/iss').toLowerCase());
    var fallback = opts.fallback || '/iss/home';
    // Separar exclusivamente por '>'
    var parts = splitBreadcrumbByChevronOnly(input);
    // Slugify cada parte
    var slugs = parts
        .map(function (p) { return slugify(p); })
        .filter(function (p) { return !!p; });
    function sanitizedFallback() {
        var fbSegs = (fallback || '/iss/home')
            .split('/')
            .map(function (s) { return slugify(s); })
            .filter(function (s) { return !!s; });
        var fbPath = '/' + fbSegs.join('/');
        fbPath = normalizeSlashesNoRegex(fbPath);
        return fbPath;
    }
    if (!slugs.length) {
        return sanitizedFallback();
    }
    var baseSegs = prefix
        ? prefix.split('/').map(function (s) { return slugify(s); }).filter(function (s) { return !!s; })
        : [];
    var startsWithBase = baseSegs.length > 0 &&
        slugs.slice(0, baseSegs.length).join('/') === baseSegs.join('/');
    var resultSegs;
    if (startsWithBase) {
        if (slugs.length === baseSegs.length) {
            return sanitizedFallback();
        }
        resultSegs = slugs;
    }
    else {
        resultSegs = baseSegs.concat(slugs);
    }
    var result = '/' + resultSegs.join('/');
    result = normalizeSlashesNoRegex(result);
    if (baseSegs.length && result === '/' + baseSegs.join('/')) {
        return sanitizedFallback();
    }
    return result;
}
export function sanitizeOperatorId(input) {
    var OPERATOR_ID_REGEX_STRICT = new RegExp('^[a-z0-9|:]+(-[a-z0-9|:]+)*(\\-[a-z0-9|:]+(-[a-z0-9|:]+)*)*$');
    if (input === null || input === undefined)
        return null;
    // 1) Stringify + trim + decode (caso venha percent-encoded) + remove acentos + lowercase
    var s = String(input).trim();
    if (!s)
        return null;
    // Reuso de utilitários já presentes no arquivo
    s = tryDecode(s);
    s = removeAccentsPtBR(s).toLowerCase();
    // 2) Substitui qualquer caractere NÃO permitido por hífen (mantém a-z, 0-9, |, :, e "-")
    s = s.replace(/[^a-z0-9|:\-]+/g, '-');
    // 3) Colapsa múltiplos hífens
    s = s.replace(/-+/g, '-');
    // 4) Remove hífens de início/fim
    s = trimHyphens(s);
    // 5) Se vazio após limpeza, invalida
    if (!s)
        return null;
    // 6) Validação final rigorosa com a regex informada
    if (!OPERATOR_ID_REGEX_STRICT.test(s)) {
        return null;
    }
    return s;
}
export function sanitizeSearchTerm(input, maxLen) {
    if (maxLen === void 0) { maxLen = 64; }
    var s = (input != null ? String(input) : '').trim();
    if (!s)
        return '';
    // Caso venha percent-encoded (ex.: "%C3%81"), decodifica com fallback
    s = tryDecode(s);
    // Normaliza para slug controlado usando separadores permitidos ':-'
    // sanitizeLabel já remove diacríticos, põe em minúsculas,
    // converte sequências inválidas para '-', colapsa e remove nas bordas.
    s = sanitizeLabel(s, { allowedSeparators: ':-', replacement: '-', trimEdges: true });
    if (!s)
        return '';
    // Limite de tamanho por segurança
    if (s.length > maxLen)
        s = s.slice(0, maxLen);
    // Validação estrita: segmentos alfanuméricos separados por '-' e/ou ':'
    var STRICT = /^[a-z0-9]+(?:[:\-][a-z0-9]+)*$/;
    return STRICT.test(s) ? s : '';
}
